import { Controller } from '@hotwired/stimulus';
import { easepick } from '@easepick/bundle';
import { LockPlugin } from '@easepick/lock-plugin';
import moment from 'moment';
import 'js-loading-overlay';

export default class extends Controller {
  static targets = [
    'installationDateInput',
    'installationSlotInput',
    'installationScheduleIdInput',
  ];

  connect() {
    this.refreshPath = this.element.dataset.refreshPath;
    this.startDate = moment.utc(this.element.dataset.startDate);
    this.selectedDate = this.element.dataset.selectedDate
      ? moment.utc(this.element.dataset.selectedDate)
      : null;
    this.customCssPath = this.element.dataset.customCssPath;
    this.availableDates = [];
    this.installationSlotInputTarget.addEventListener(
      'change',
      this.slotSelected.bind(this),
    );

    this.setupPicker();
    this.changeMonth(0);
  }

  async changeMonth(increment) {
    JsLoadingOverlay.show({
      spinnerIcon: 'ball-clip-rotate-multiple',
      spinnerSize: '1x',
    });

    const oldUrl = new URL(this.refreshPath);
    const sp = oldUrl.searchParams;
    const newStartDate = this.startDate.add(increment, 'months');
    sp.set('start_date', newStartDate.toISOString());
    const url = `${this.refreshPath}?${sp.toString()}`;
    const r = await fetch(url, { headers: { Accept: 'application/json' } });
    this.availableDates = await r.json();
    if (this.availableDates.length === 0) {
      this.availableDates = this.preferredDates();
    }

    this.picker.gotoDate(newStartDate.toISOString());
    JsLoadingOverlay.hide();
  }

  dateIsDisabled(date, _picked) {
    return !this.availableDates.some(
      (id) => id.slot_date === date.format('YYYY-MM-DD'),
    );
  }

  dateSelected(e) {
    const { date } = e.detail;
    const id = this.availableDates.find(
      (id) => id.slot_date === date.format('YYYY-MM-DD'),
    );

    // enable/prompt for slot
    ['AM', 'PM'].forEach((slot) => {
      const option = this.installationSlotInputTarget.querySelector(
        `option[value="${slot}"]`,
      );
      option.dataset.slotId = id[`${slot.toLowerCase()}_slot_id`];
      option.disabled = !id[slot.toLowerCase()];
      option.selected = false;
    });
    const prompt =
      this.installationSlotInputTarget.querySelector('option[value=""]');
    prompt.innerHTML =
      id.am || id.pm ? 'Please select a slot' : 'No slots available';
  }

  disconnect() {
    this.picker.destroy();
  }

  hookupEvents(picker) {
    // picker.onClickHeaderButton = (e) => {
    //   if (
    //     !e.classList.contains('next-button') &&
    //     !e.classList.contains('previous-button')
    //   )
    //     return;
    //   this.changeMonth(e.classList.contains('next-button') ? 1 : -1);
    // };
    picker.on('select', this.dateSelected.bind(this));
  }

  isMobileDevice() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  preferredDates() {
    const preferredDates = [];
    let preferredDate = moment().add(14, 'd');
    for (let idx = 0; idx < 20; idx++) {
      while ([0, 6].includes(preferredDate.weekday())) {
        preferredDate = preferredDate.add(1, 'd');
      }
      preferredDates.push({
        slot_date: preferredDate.format('YYYY-MM-DD'),
        am_slot_id: 'preferredAM',
        am: true,
        pm_slot_id: 'preferredPM',
        pm: true,
      });
      preferredDate = preferredDate.add(1, 'd');
    }
    return preferredDates;
  }

  setupPicker() {
    this.picker = new easepick.create({
      calendars: 2,
      date: this.selectedDate ? this.selectedDate.format('DD/MM/YYYY') : null,
      element: this.installationDateInputTarget,
      format: 'DD/MM/YYYY',
      grid: this.isMobileDevice() ? 1 : 2,
      plugins: [LockPlugin],
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        this.customCssPath,
      ],
      LockPlugin: {
        filter: this.dateIsDisabled.bind(this),
        minDate: moment(),
        // maxDate: moment().add(1, 'months').endOf('month'),
      },
      setup: this.hookupEvents.bind(this),
      zIndex: 1,
    });
  }

  slotSelected(e) {
    const slotId =
      e.currentTarget[e.currentTarget.selectedIndex].dataset.slotId;
    this.installationScheduleIdInputTarget.value = slotId;
  }
}
